<template>
  <div
    v-if="isShow"
    :class="isMobile ? 'emoji-container' : 'emoji-container-pc'"
  >
    <van-swipe class="my-swipe" indicator-color="#007aff" v-if="isMobile">
      <van-swipe-item v-for="(p, i) in emojis" :key="i">
        <ul>
          <li
            @click="appendEmoji(item.en)"
            v-for="item in p"
            :key="item.cn"
            style="width: 11.11%;display: inline-block;"
          >
            <i :class="'emoji-' + item.en"></i>
          </li>
        </ul>
      </van-swipe-item>
    </van-swipe>
    <div v-if="!isMobile">
      <ul v-for="(p, i) in emojis" :key="i">
        <li
          @click="appendEmoji(item.en)"
          v-for="item in p"
          :key="item.cn"
          style="width: 11.11%;display: inline-block;"
        >
          <i :class="'emoji-' + item.en"></i>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { emoji, symbolReg, replaceColon as rc } from "../../common/emoji";
import $ from "jquery";
import { $subscriber } from "fire-wind-water";

export default {
  name: "Emoji",
  props: ["isMobile"],
  data() {
    return {
      emoji: emoji,
      emojis: [],
      symbolReg: symbolReg,
      isShow: false,
      emojiReg: null,
      regStr: [],
      hasFocus: false,
      selection: null,
      emojiMap: {},
      emojiEditor: null,
      content: ""
    };
  },
  methods: {
    toggle() {
      this.isShow = !this.isShow;
    },
    //分组
    initEmojis() {
      let temp = [];
      for (let i in this.emoji) {
        this.regStr.push(this.emoji[i].en);
        temp.push(this.emoji[i]);
        this.emojiMap[this.emoji[i].en] = this.emoji[i].symbol;
        if (
          (parseInt(i) + 1) % 27 == 0 ||
          parseInt(i) == this.emoji.length - 1
        ) {
          this.emojis.push(temp);
          temp = [];
        }
      }
    },
    replaceColon(emojiText) {
      return !emojiText
        ? ""
        : emojiText.replace(this.emojiReg, function(match, text) {
            var url = require("@/assets/images/emoji/" + text + ".png");
            return "<img src='" + url + "' alt='" + emojiText + "'/>";
          });
    },
    insert(text, emoji) {
      $(".edit-able").focus();
      if (this.selection) {
        this.restoreSelection(this.selection);
      }
      this.replaceSelection(text, emoji);
    },
    appendEmoji(emoji) {
      this.insert($(this.replaceColon(":" + emoji + ":"))[0], emoji);
    },
    restoreSelection(savedSelection) {
      var sel = window.getSelection();
      sel.removeAllRanges();
      for (var i = 0, len = savedSelection.length; i < len; ++i) {
        sel.addRange(savedSelection[i]);
      }
    },
    saveSelection() {
      var sel = window.getSelection();
      var ranges = [];
      if (sel.rangeCount) {
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          ranges.push(sel.getRangeAt(i));
        }
      }
      return ranges;
    },
    replaceSelection(content) {
      var self = this;
      var range,
        sel = window.getSelection();
      var node =
        typeof content === "string"
          ? document.createTextNode(content)
          : content;
      if (sel.getRangeAt && sel.rangeCount) {
        range = sel.getRangeAt(0);
        range.deleteContents();
        range.insertNode(node);
        range.setStart(node, 0);
        window.setTimeout(function() {
          range = document.createRange();
          range.setStartAfter(node);
          range.collapse(true);
          sel.removeAllRanges();
          sel.addRange(range);
        }, 0);
      }
      self.content = this.getContent();
      self.$emit("change", self.content);
      setTimeout(() => {
        $(".edit-able").scrollLeft(10000);
      }, 26);
    },
    getContent() {
      var self = this;
      var children = $(".edit-able")[0].childNodes;
      let content = "";
      for (let i of children) {
        if (i.nodeType == 1) {
          ///img
          if (["div", "pre", "form"].indexOf(i.tagName.toLowerCase()) > -1) {
            if (i.tagName.toLowerCase() == "div") {
              //兼容一下文本中的带换行的win7
              if ($(i).children("span").length > 0) {
                content +=
                  $(i)
                    .children("span")
                    .html() + " ";
              } else if (i.childNodes && i.childNodes[0].nodeType == 3) {
                content +=
                  (i.childNodes[0] && i.childNodes[0].wholeText
                    ? i.childNodes[0].wholeText
                    : "") + " ";
              } else {
                content += "";
              }
            } else {
              content += "";
            }
          } else if (
            i.tagName.toLowerCase() == "span" ||
            i.tagName.toLowerCase() == "p"
          ) {
            let text = $(i).html();
            content += text;
          } else {
            content += i.getAttribute("alt") || "";
          }
        } else if (i.nodeType == 3) {
          content += i.wholeText ? i.wholeText : "";
        }
      }
      return content.replace(this.emojiReg, function(match, text) {
        return self.emojiMap[text];
      });
    },
    clear() {
      $(".edit-able").html("");
      this.content = "";
      this.$emit("change", this.content);
    },
    dealInput() {
      this.content = this.getContent();
      $(".edit-able").scrollLeft(10000);
      this.$emit("change", this.content);
    }
  },
  created() {
    let self = this;
    this.$on("showEmoji", () => {
      self.toggle();
    });
    this.initEmojis();
    this.emojiReg = new RegExp(":(" + this.regStr.join("|") + "):", "g");
  },

  mounted() {
    var self = this;
    var emojiEditor = $(".edit-able");
    emojiEditor.on("focus", function() {
      self.hasFocus = true;
      //将光标指向内容最后
      if (
        typeof window.getSelection != "undefined" &&
        typeof document.createRange != "undefined"
      ) {
        var range = document.createRange();
        range.selectNodeContents(emojiEditor[0]);
        range.collapse(false);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } else if (typeof document.body.createTextRange != "undefined") {
        var textRange = document.body.createTextRange();
        textRange.moveToElementText(emojiEditor[0]);
        textRange.collapse(false);
        textRange.select();
      }
    });
    emojiEditor.on("blur", function() {
      self.hasFocus = false;
    });
    document.addEventListener("click", function(e) {
      if (
        !$(e.target).hasClass("smiley") &&
        !$(e.target).hasClass("emoji-container") &&
        !(
          $(e.target).attr("class") &&
          $(e.target)
            .attr("class")
            .indexOf("emoji-") >= 0
        )
      ) {
        self.isShow = false;
      }
      if (
        $(e.target).hasClass("qa-img") &&
        !$(e.target)
          .parent()
          .parent()
          .hasClass("text-content")
      ) {
        var src = $(e.target).prop("src");
        $subscriber.emit("showPopup", { src: src });
      }
    });
    var flag = true;
    emojiEditor.on("compositionstart", function() {
      flag = false;
    });
    emojiEditor.on("compositionend", function() {
      flag = true;

      self.content = self.getContent();
      //      $(".edit-able").html(rc(self.content));
      //      $(".edit-able").focus();
      $(".edit-able").scrollLeft(10000);
      self.$emit("change", self.content);
    });
    emojiEditor.on("input", function() {
      if (flag) {
        self.content = self.getContent();
        //        $(".edit-able").html(rc(self.content));
        //        $(".edit-able").focus();
        rc;
        $(".edit-able").scrollLeft(10000);
        self.$emit("change", self.content);
      }
      setTimeout(function() {}, 0);
    });

    //兼容IE事件触发
    if (document.getElementById("discuss-edit")) {
      document.getElementById("discuss-edit").addEventListener(
        "DOMNodeInserted",
        function() {
          self.dealInput();
        },
        false
      );
      document.getElementById("discuss-edit").addEventListener(
        "DOMNodeRemoved",
        function() {
          self.dealInput();
        },
        false
      );
      document.getElementById("discuss-edit").addEventListener(
        "DOMCharacterDataModified",
        function() {
          self.dealInput();
        },
        false
      );
    }

    $(document).on("mousedown keydown", function() {
      if (self.hasFocus) {
        self.selection = self.saveSelection();
      }
    });
  }
};
</script>

<style lang="scss">
.emoji-sprite-base,
.emoji--1,
.emoji-100,
.emoji-alien,
.emoji-anguished,
.emoji-bear,
.emoji-beetle,
.emoji-blush,
.emoji-bomb,
.emoji-broken_heart,
.emoji-clap,
.emoji-cold_sweat,
.emoji-confounded,
.emoji-confused,
.emoji-cow,
.emoji-crescent_moon,
.emoji-cry,
.emoji-disappointed_relieved,
.emoji-dizzy_face,
.emoji-expressionless,
.emoji-facepunch,
.emoji-fearful,
.emoji-fire,
.emoji-flushed,
.emoji-footprints,
.emoji-ghost,
.emoji-grimacing,
.emoji-grin,
.emoji-grinning,
.emoji-hankey,
.emoji-hear_no_evil,
.emoji-heart_eyes,
.emoji-hibiscus,
.emoji-hushed,
.emoji-imp,
.emoji-innocent,
.emoji-joy,
.emoji-joy_cat,
.emoji-kiss,
.emoji-kissing_closed_eyes,
.emoji-kissing_heart,
.emoji-laughing,
.emoji-lollipop,
.emoji-mask,
.emoji-moneybag,
.emoji-muscle,
.emoji-no_mouth,
.emoji-ok_hand,
.emoji-pensive,
.emoji-persevere,
.emoji-pig,
.emoji-pray,
.emoji-rage,
.emoji-relieved,
.emoji-rocket,
.emoji-scream,
.emoji-scream_cat,
.emoji-see_no_evil,
.emoji-sleeping,
.emoji-sleepy,
.emoji-smile,
.emoji-smiley,
.emoji-smiling_imp,
.emoji-smirk,
.emoji-sob,
.emoji-sparkling_heart,
.emoji-speak_no_evil,
.emoji-stuck_out_tongue,
.emoji-stuck_out_tongue_closed_eyes,
.emoji-stuck_out_tongue_winking_eye,
.emoji-sunglasses,
.emoji-sunny,
.emoji-sweat,
.emoji-sweat_smile,
.emoji-tea,
.emoji-triumph,
.emoji-unamused,
.emoji-wave,
.emoji-weary,
.emoji-wink,
.emoji-zan {
  background-image: url("../../assets/images/emoji/emoji.png"),
    url("../../assets/images/emoji/emoji.png");
  background-repeat: no-repeat;
}

.my-swipe {
  height: 100%;

  .van-swipe-item {
    height: 100%;
    color: #fff;
    font-size: 20px;
    text-align: center;
    background-color: #ffffff;
    box-sizing: border-box;
  }
}
.qa-img {
  height: 30px;
  max-width: 100%;
}
</style>
